import React from 'react'
import * as R from 'ramda'
import Moment from 'moment'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import {List, ListItem} from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'

import PortfolioCard from './PortfolioCard'
import { sortSev } from 'utils/stuff'

export default (o) => (
	<div id="main-content"
		style={{
			marginLeft: (o.navPanelIsOpened)?"230px" : '0'
		  , marginRight: (o.rightStackOpened)? '600px': "0"
		  , marginTop: "50px"
		  , overflow: 'scroll'
		  , height: 'calc(100vh - 45px)'
		}}
	>
		<List>
			{(R.keys(o.portfolios).length)?
				R.map((portfolio) => (
					<PortfolioCard
						key={`portfolio-${portfolio._id}`}
						portfolio={portfolio}
						id={portfolio._id}
						openPanel={o.openPanel}
						lastInteracted={o.lastInteracted}
					/>
			),  sortSev(o.portfolios, "firstName", "lastName"))
				: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No portfolios</p>
			}
		</List>
	</div>
)
/*{()=> {

}}*/



// WEBPACK FOOTER //
// ./src/routes/manager/portfolios/PortfoliosList.js